import React, { useContext, useEffect } from "react";

import { LiveEventTypeTrackingEnum } from "@data-types/analytics-tracker/AnalyticsTrackerEnum";
import {
	EventFullInfo,
	EventPageSubheader,
} from "@features/offer/desktop/event";
import { EventContext, OfferStoreContext } from "@gp/components";
import { useRootAppStore } from "@hooks";
import { history } from "@state";
import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { analyticsTracker } from "@utils/analytics";
import classnames from "classnames";
import { observer } from "mobx-react";

import { EventFooter } from ".";

export default observer(function EventTemplate() {
	const store = useContext(OfferStoreContext) as EventViewStore;
	const event = useContext(EventContext);
	const liveEventMenuViewStore = useContext(LiveEventSideMenuContext);
	const rootStore = useRootAppStore();

	const onClose = () => {
		if (store.multiEventViewStore?.isMultiEvent) {
			liveEventMenuViewStore.removeEvent(event.id);
			rootStore.myBetsViewStore.cashoutStore.disposeSubscription(
				event.id
			);
			return;
		}

		if (liveEventMenuViewStore.onClose) {
			liveEventMenuViewStore.onClose();
			return;
		}
		return history.goBack();
	};

	const eventsSize = store.multiEventViewStore?.eventsViewMap.size || 0;

	useEffect(() => {
		if (event.isLive && eventsSize == 1) {
			analyticsTracker.trackLiveEventInteraction(
				LiveEventTypeTrackingEnum.LiveEventPageOpened
			);
		}
	}, []);

	const eventWrapperClasses = classnames("event event--page", {
		"event--live": event.isLive,
		"event--multi": eventsSize > 1,
	});

	const multiEventWrapperDiv = classnames("col u-mar--bottom--xsml", {
		"event--multi__col": eventsSize > 1,
	});

	return (
		<div className={multiEventWrapperDiv} id={`event-${event.id}`}>
			<div className={eventWrapperClasses}>
				<EventPageSubheader onClose={onClose} />
				<EventFullInfo />
				<EventFooter />
			</div>
		</div>
	);
});
